/* tslint:disable */
/* eslint-disable */
/* istanbul ignore file */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.10.7.0 (NJsonSchema v10.3.9.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable({
  providedIn: 'root'
})
export class DirectDepositAPIClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @return Success
   */
  branch(transitNumber: string | null): Observable<Branch[]> {
    let url_ = this.baseUrl + "/api/v1/directdeposit/branch/{transitNumber}";
    if (transitNumber === undefined || transitNumber === null)
      throw new Error("The parameter 'transitNumber' must be defined.");
    url_ = url_.replace("{transitNumber}", encodeURIComponent("" + transitNumber));
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processBranch(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processBranch(<any>response_);
        } catch (e) {
          return <Observable<Branch[]>><any>_observableThrow(e);
        }
      } else
        return <Observable<Branch[]>><any>_observableThrow(response_);
    }));
  }

  protected processBranch(response: HttpResponseBase): Observable<Branch[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(Branch.fromJS(item));
        }
        if (result200 && result200.length === 0) {
          return throwException("Not Found", 404, "", _headers, result200);
        }
        else {
          return _observableOf(result200);
        }
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData404)) {
          result404 = [] as any;
          for (let item of resultData404)
            result404!.push(Branch.fromJS(item));
        }
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result401: any = null;
        let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData401)) {
          result401 = [] as any;
          for (let item of resultData401)
            result401!.push(Branch.fromJS(item));
        }
        return throwException("Unauthorized", status, _responseText, _headers, result401);
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData400)) {
          result400 = [] as any;
          for (let item of resultData400)
            result400!.push(Branch.fromJS(item));
        }
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf(null);
  }

  /**
   * @return Success
   */
  worker(): Observable<WorkerDirectDepositDTO> {
    let url_ = this.baseUrl + "/api/v1/directdeposit/worker";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processWorker(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processWorker(<any>response_);
        } catch (e) {
          return <Observable<WorkerDirectDepositDTO>><any>_observableThrow(e);
        }
      } else
        return <Observable<WorkerDirectDepositDTO>><any>_observableThrow(response_);
    }));
  }

  protected processWorker(response: HttpResponseBase): Observable<WorkerDirectDepositDTO> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = WorkerDirectDepositDTO.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result404: any = null;
        let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = WorkerDirectDepositDTO.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result401: any = null;
        let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = WorkerDirectDepositDTO.fromJS(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = WorkerDirectDepositDTO.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<WorkerDirectDepositDTO>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  workerFinancialInstitutionAccount(body: Body2 | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/v1/directdeposit/workerFinancialInstitutionAccount";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processWorkerFinancialInstitutionAccount(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processWorkerFinancialInstitutionAccount(<any>response_);
        } catch (e) {
          return <Observable<void>><any>_observableThrow(e);
        }
      } else
        return <Observable<void>><any>_observableThrow(response_);
    }));
  }

  protected processWorkerFinancialInstitutionAccount(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(<any>null);
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result401: any = null;
        let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * @return Success
   */
  cancelDirectDepositEnrollment(): Observable<void> {
    let url_ = this.baseUrl + "/api/v1/directdeposit/cancelDirectDepositEnrollment";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processCancelDirectDepositEnrollment(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processCancelDirectDepositEnrollment(<any>response_);
        } catch (e) {
          return <Observable<void>><any>_observableThrow(e);
        }
      } else
        return <Observable<void>><any>_observableThrow(response_);
    }));
  }

  protected processCancelDirectDepositEnrollment(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return _observableOf<void>(<any>null);
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result401: any = null;
        let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<void>(<any>null);
  }
}

export enum BranchStatusCode {
  V = "V",
  C = "C",
  X = "X",
}

export class Branch implements IBranch {
  institutionNumber?: string;
  institutionName?: string;
  transitNumber?: string;
  branchName?: string;
  branchAddress?: string;
  postalCode?: string;
  provinceCode?: string;
  city?: string;
  effectiveDatetime?: Date;
  statusCode?: BranchStatusCode;

  constructor(data?: IBranch) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.institutionNumber = _data["institutionNumber"];
      this.institutionName = _data["institutionName"];
      this.transitNumber = _data["transitNumber"];
      this.branchName = _data["branchName"];
      this.branchAddress = _data["branchAddress"];
      this.postalCode = _data["postalCode"];
      this.provinceCode = _data["provinceCode"];
      this.city = _data["city"];
      this.effectiveDatetime = _data["effectiveDatetime"] ? new Date(_data["effectiveDatetime"].toString()) : <any>undefined;
      this.statusCode = _data["statusCode"];
    }
  }

  static fromJS(data: any): Branch {
    data = typeof data === 'object' ? data : {};
    let result = new Branch();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["institutionNumber"] = this.institutionNumber;
    data["institutionName"] = this.institutionName;
    data["transitNumber"] = this.transitNumber;
    data["branchName"] = this.branchName;
    data["branchAddress"] = this.branchAddress;
    data["postalCode"] = this.postalCode;
    data["provinceCode"] = this.provinceCode;
    data["city"] = this.city;
    data["effectiveDatetime"] = this.effectiveDatetime ? this.effectiveDatetime.toISOString() : <any>undefined;
    data["statusCode"] = this.statusCode;
    return data;
  }
}

export interface IBranch {
  institutionNumber?: string;
  institutionName?: string;
  transitNumber?: string;
  branchName?: string;
  branchAddress?: string;
  postalCode?: string;
  provinceCode?: string;
  city?: string;
  effectiveDatetime?: Date;
  statusCode?: BranchStatusCode;
}

export enum AddressType {
  Mailing = "Mailing",
  Street = "Street",
}

export class AddressDTO implements IAddressDTO {
  addressLine1?: string | undefined;
  addressLine2?: string | undefined;
  addressLine3?: string | undefined;
  addressLine4?: string | undefined;
  city?: string | undefined;
  provinceState?: string | undefined;
  country?: string | undefined;
  postalCode?: string | undefined;
  preferredIndicator?: boolean | undefined;
  addressType?: AddressType;

  constructor(data?: IAddressDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.addressLine1 = _data["addressLine1"];
      this.addressLine2 = _data["addressLine2"];
      this.addressLine3 = _data["addressLine3"];
      this.addressLine4 = _data["addressLine4"];
      this.city = _data["city"];
      this.provinceState = _data["provinceState"];
      this.country = _data["country"];
      this.postalCode = _data["postalCode"];
      this.preferredIndicator = _data["preferredIndicator"];
      this.addressType = _data["addressType"];
    }
  }

  static fromJS(data: any): AddressDTO {
    data = typeof data === 'object' ? data : {};
    let result = new AddressDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["addressLine1"] = this.addressLine1;
    data["addressLine2"] = this.addressLine2;
    data["addressLine3"] = this.addressLine3;
    data["addressLine4"] = this.addressLine4;
    data["city"] = this.city;
    data["provinceState"] = this.provinceState;
    data["country"] = this.country;
    data["postalCode"] = this.postalCode;
    data["preferredIndicator"] = this.preferredIndicator;
    data["addressType"] = this.addressType;
    return data;
  }
}

export interface IAddressDTO {
  addressLine1?: string | undefined;
  addressLine2?: string | undefined;
  addressLine3?: string | undefined;
  addressLine4?: string | undefined;
  city?: string | undefined;
  provinceState?: string | undefined;
  country?: string | undefined;
  postalCode?: string | undefined;
  preferredIndicator?: boolean | undefined;
  addressType?: AddressType;
}

export enum DirectDepositStatus {
  Unknown = "Unknown",
  New = "New",
  EnrolledByPortal = "EnrolledByPortal",
  EnrolledByCMS = "EnrolledByCMS",
  UpdatedByPortal = "UpdatedByPortal",
  UpdatedByCMS = "UpdatedByCMS",
  CancelledByPortal = "CancelledByPortal",
  CancelledByCMS = "CancelledByCMS",
}

export class WorkerDirectDepositDTO implements IWorkerDirectDepositDTO {
  customerCareNumber?: string | undefined;
  workerFirstName?: string | undefined;
  workerLastName?: string | undefined;
  institutionId?: string | undefined;
  transitNumber?: string | undefined;
  bankName?: string | undefined;
  branchAddress?: string | undefined;
  accountNumber?: string | undefined;
  effectiveDate?: Date | undefined;
  address?: AddressDTO;
  status?: DirectDepositStatus;

  constructor(data?: IWorkerDirectDepositDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.customerCareNumber = _data["customerCareNumber"];
      this.workerFirstName = _data["workerFirstName"];
      this.workerLastName = _data["workerLastName"];
      this.institutionId = _data["institutionId"];
      this.transitNumber = _data["transitNumber"];
      this.bankName = _data["bankName"];
      this.branchAddress = _data["branchAddress"];
      this.accountNumber = _data["accountNumber"];
      this.effectiveDate = _data["effectiveDate"] ? new Date(_data["effectiveDate"].toString()) : <any>undefined;
      this.address = _data["address"] ? AddressDTO.fromJS(_data["address"]) : <any>undefined;
      this.status = _data["status"];
    }
  }

  static fromJS(data: any): WorkerDirectDepositDTO {
    data = typeof data === 'object' ? data : {};
    let result = new WorkerDirectDepositDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["customerCareNumber"] = this.customerCareNumber;
    data["workerFirstName"] = this.workerFirstName;
    data["workerLastName"] = this.workerLastName;
    data["institutionId"] = this.institutionId;
    data["transitNumber"] = this.transitNumber;
    data["bankName"] = this.bankName;
    data["branchAddress"] = this.branchAddress;
    data["accountNumber"] = this.accountNumber;
    data["effectiveDate"] = this.effectiveDate ? this.effectiveDate.toISOString() : <any>undefined;
    data["address"] = this.address ? this.address.toJSON() : <any>undefined;
    data["status"] = this.status;
    return data;
  }
}

export interface IWorkerDirectDepositDTO {
  customerCareNumber?: string | undefined;
  workerFirstName?: string | undefined;
  workerLastName?: string | undefined;
  institutionId?: string | undefined;
  transitNumber?: string | undefined;
  bankName?: string | undefined;
  branchAddress?: string | undefined;
  accountNumber?: string | undefined;
  effectiveDate?: Date | undefined;
  address?: AddressDTO;
  status?: DirectDepositStatus;
}

export enum FinancialInstitutionAccountType {
  Unknown = "Unknown",
  Chequing = "Chequing",
  Savings = "Savings",
}

export class FinancialInstitutionAccount implements IFinancialInstitutionAccount {
  accountNumber!: string;
  transitNumber!: string;
  institutionNumber!: string;
  financialInstitutionAccountType?: FinancialInstitutionAccountType;
  preferredIndicator!: boolean;
  effectiveDatetime?: Date;
  expiryDatetime?: Date | undefined;

  constructor(data?: IFinancialInstitutionAccount) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.accountNumber = _data["accountNumber"];
      this.transitNumber = _data["transitNumber"];
      this.institutionNumber = _data["institutionNumber"];
      this.financialInstitutionAccountType = _data["financialInstitutionAccountType"];
      this.preferredIndicator = _data["preferredIndicator"];
      this.effectiveDatetime = _data["effectiveDatetime"] ? new Date(_data["effectiveDatetime"].toString()) : <any>undefined;
      this.expiryDatetime = _data["expiryDatetime"] ? new Date(_data["expiryDatetime"].toString()) : <any>undefined;
    }
  }

  static fromJS(data: any): FinancialInstitutionAccount {
    data = typeof data === 'object' ? data : {};
    let result = new FinancialInstitutionAccount();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["accountNumber"] = this.accountNumber;
    data["transitNumber"] = this.transitNumber;
    data["institutionNumber"] = this.institutionNumber;
    data["financialInstitutionAccountType"] = this.financialInstitutionAccountType;
    data["preferredIndicator"] = this.preferredIndicator;
    data["effectiveDatetime"] = this.effectiveDatetime ? this.effectiveDatetime.toISOString() : <any>undefined;
    data["expiryDatetime"] = this.expiryDatetime ? this.expiryDatetime.toISOString() : <any>undefined;
    return data;
  }
}

export interface IFinancialInstitutionAccount {
  accountNumber: string;
  transitNumber: string;
  institutionNumber: string;
  financialInstitutionAccountType?: FinancialInstitutionAccountType;
  preferredIndicator: boolean;
  effectiveDatetime?: Date;
  expiryDatetime?: Date | undefined;
}

export class Body2 implements IBody2 {
  customerCareNumber!: number;
  financialInstitutionAccount!: FinancialInstitutionAccount;

  constructor(data?: IBody2) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.financialInstitutionAccount = new FinancialInstitutionAccount();
    }
  }

  init(_data?: any) {
    if (_data) {
      this.customerCareNumber = _data["customerCareNumber"];
      this.financialInstitutionAccount = _data["financialInstitutionAccount"] ? FinancialInstitutionAccount.fromJS(_data["financialInstitutionAccount"]) : new FinancialInstitutionAccount();
    }
  }

  static fromJS(data: any): Body2 {
    data = typeof data === 'object' ? data : {};
    let result = new Body2();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["customerCareNumber"] = this.customerCareNumber;
    data["financialInstitutionAccount"] = this.financialInstitutionAccount ? this.financialInstitutionAccount.toJSON() : <any>undefined;
    return data;
  }
}

export interface IBody2 {
  customerCareNumber: number;
  financialInstitutionAccount: FinancialInstitutionAccount;
}

export class ProblemDetails implements IProblemDetails {
  type?: string | undefined;
  title?: string | undefined;
  status?: number | undefined;
  detail?: string | undefined;
  instance?: string | undefined;

  constructor(data?: IProblemDetails) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.type = _data["type"];
      this.title = _data["title"];
      this.status = _data["status"];
      this.detail = _data["detail"];
      this.instance = _data["instance"];
    }
  }

  static fromJS(data: any): ProblemDetails {
    data = typeof data === 'object' ? data : {};
    let result = new ProblemDetails();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["type"] = this.type;
    data["title"] = this.title;
    data["status"] = this.status;
    data["detail"] = this.detail;
    data["instance"] = this.instance;
    return data;
  }
}

export interface IProblemDetails {
  type?: string | undefined;
  title?: string | undefined;
  status?: number | undefined;
  detail?: string | undefined;
  instance?: string | undefined;
}

export class ApiException extends Error {
  message: string;
  status: number;
  response: string;
  headers: { [key: string]: any; };
  result: any;

  constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isApiException = true;

  static isApiException(obj: any): obj is ApiException {
    return obj.isApiException === true;
  }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
  if (result !== null && result !== undefined)
    return _observableThrow(result);
  else
    return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
  return new Observable<string>((observer: any) => {
    if (!blob) {
      observer.next("");
      observer.complete();
    } else {
      let reader = new FileReader();
      reader.onload = event => {
        observer.next((<any>event.target).result);
        observer.complete();
      };
      reader.readAsText(blob);
    }
  });
}


